// import React, { useState, useEffect } from "react";
// import "./homecleanOrderForm.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTimes } from "@fortawesome/free-solid-svg-icons";
// import axios from "axios";

// const HomeCleanOrderForm = ({ user, formData, onClose, serviceId }) => {
//   const [orderData, setOrderData] = useState({
//     city: user?.city || "",
//     address: user?.Address || "",
//     mobile: user?.mobile || "",
//   });
//   const [showSuccessPopup, setShowSuccessPopup] = useState(false);
//   const [showForm, setShowForm] = useState(true);

//   // Compute penalty and final price (base price + penalty)
//   const penalty = user && user.penalty ? Number(user.penalty) : 0;
//   console.log("use penalty", penalty);
//   const basePrice = Number(formData.price) || 0;
//   const finalPrice = user.penaltyReserved
//     ? basePrice
//     : basePrice + (user.penalty ? Number(user.penalty) : 0);

//   useEffect(() => {
//     if (user) {
//       setOrderData({
//         city: user.city || "",
//         address: user.Address || "",
//         mobile: user.mobile || "",
//       });
//     }
//   }, [user]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setOrderData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const finalOrderData = {
//       userId: user.Id, // Assuming `user.Id` contains the user's ID
//       usercity: orderData.city,
//       useraddress: orderData.address,
//       bed: formData.bedrooms,
//       bath: formData.bathrooms,
//       dra_din: formData.drawingdinning,
//       kitchen: formData.kitchens,
//       cloth: formData.cloths,
//       dish: formData.dishes,
//       price: formData.price,
//       // price: finalPrice,
//       date: formData.date,
//       time: formData.time,
//       status: "pending", // Set an initial status
//       servitor_id: 0, // Assuming 0 for now, you might want to get this dynamically
//       serviceId: 2, // Adding the serviceId here
//     };

//     try {
//       const response = await axios.post(
//         "http://localhost:4001/homeclean",
//         finalOrderData
//       );
//       console.log("Order placed successfully:", response.data);
//       // onClose();
//       setShowForm(false);
//       setShowSuccessPopup(true);
//     } catch (error) {
//       console.error("Error placing order:", error);
//     }
//   };

//   const closePopup = () => {
//     setShowSuccessPopup(false);
//     onClose();
//   };

//   return (
//     <>
//       {showForm && (
//         <div className="homecleanorder-modal">
//           <div className="homecleanorder-overlay" onClick={onClose}></div>
//           <div className="homecleanorder-form-container">
//             <div className="homecleanorder-form-header">
//               <div className="header-content">
//                 <h2>Order Details</h2>
//               </div>
//               <button className="close-button" onClick={onClose}>
//                 <FontAwesomeIcon icon={faTimes} />
//               </button>
//             </div>
//             <hr />
//             <div className="homecleanorder-form-content">
//               <div className="homecleanorder-left">
//                 <div className="homecleanorder-row">
//                   <div className="homecleanorder-col">
//                     <label>Name</label>
//                     <input
//                       type="text"
//                       value={`${user.FirstName} ${user.LastName}`}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="homecleanorder-row">
//                   <div className="homecleanorder-col">
//                     <label>Mobile</label>
//                     <input
//                       type="text"
//                       value={"0" + orderData.mobile}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="homecleanorder-row">
//                   <div className="homecleanorder-col">
//                     <label>City</label>
//                     <select
//                       id="city"
//                       name="city"
//                       value={orderData.city}
//                       onChange={handleChange}
//                     >
//                       <option value="">Select your City</option>
//                       <option value="Dhaka">Dhaka</option>
//                       <option value="Chattogram">Chattogram</option>
//                       <option value="Barishal">Barishal</option>
//                       <option value="Sylhet">Sylhet</option>
//                       <option value="Rajshahi">Rajshahi</option>
//                       <option value="Khulna">Khulna</option>
//                       <option value="Rangpur">Rangpur</option>
//                       <option value="Maymensingh">Maymensingh</option>
//                     </select>
//                   </div>
//                 </div>
//                 <div className="homecleanorder-row">
//                   <div className="homecleanorder-col">
//                     <label>Address</label>
//                     <input
//                       type="text"
//                       name="address"
//                       value={orderData.address}
//                       onChange={handleChange}
//                     />
//                   </div>
//                 </div>
//               </div>
//               <div className="homecleanorder-right">
//                 <div className="homecleanorder-row">
//                   <div className="homecleanorder-col">
//                     <label>Bedroom</label>
//                     <input type="text" value={formData.bedrooms} readOnly />
//                   </div>
//                   <div className="homecleanorder-col">
//                     <label>Bathroom</label>
//                     <input type="text" value={formData.bathrooms} readOnly />
//                   </div>
//                   <div className="homecleanorder-col">
//                     <label>Drawing-Dinning</label>
//                     <input
//                       type="text"
//                       value={formData.drawingdinning}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="homecleanorder-row">
//                   <div className="homecleanorder-col">
//                     <label>Kitchen</label>
//                     <input type="text" value={formData.kitchens} readOnly />
//                   </div>
//                   <div className="homecleanorder-col">
//                     <label>Cloth Cleaning</label>
//                     <input type="text" value={formData.cloths} readOnly />
//                   </div>
//                   <div className="homecleanorder-col">
//                     <label>Dish Cleaning</label>
//                     <input type="text" value={formData.dishes} readOnly />
//                   </div>
//                 </div>
//                 <div className="homecleanorder-row">
//                   <div className="homecleanorder-col">
//                     <label>Date</label>
//                     <input type="date" value={formData.date} readOnly />
//                   </div>
//                   <div className="homecleanorder-col">
//                     <label>Time</label>
//                     <input type="text" value={formData.time} readOnly />
//                   </div>
//                 </div>
//                 {/* <div className="homecleanorder-row">
//                             <div className="homecleanorder-col">
//                                 <label>Total Price</label>
//                                 <input type="text" value={`${formData.price} tk`} readOnly />
//                                 <input type="text" value={`${finalPrice} tk`} readOnly />
//                             </div>
//                         </div> */}
//                 <div className="homecleanorder-row">
//                   {!user.penaltyReserved && penalty > 0 ? (
//                     <>
//                       <div className="homecleanorder-col">
//                         <label>Base Price</label>
//                         <input type="text" value={`${basePrice} tk`} readOnly />
//                       </div>
//                       <div className="homecleanorder-col">
//                         <label>Penalty</label>
//                         <input type="text" value={`${penalty} tk`} readOnly />
//                       </div>
//                       <div className="homecleanorder-col">
//                         <label>Total Price</label>
//                         <input
//                           type="text"
//                           value={`${finalPrice} tk`}
//                           readOnly
//                         />
//                       </div>
//                     </>
//                   ) : (
//                     <div className="homecleanorder-col">
//                       <label>Total Price</label>
//                       <input type="text" value={`${finalPrice} tk`} readOnly />
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//             <div className="homecleanorder-button-container">
//               <button
//                 type="submit"
//                 className="homecleanorder-button"
//                 onClick={handleSubmit}
//               >
//                 Place Order
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//       {showSuccessPopup && (
//         <div className="success-popup">
//           <div className="success-popup-content">
//             <h2>Order successfully placed!</h2>
//             <p>Thank you</p>
//             <p>Stay with HelpNao</p>
//             <button onClick={closePopup}>Ok</button>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default HomeCleanOrderForm;

// ************************ All working fine ************************* //

// import React, { useState, useEffect } from "react";
// import "./homecleanOrderForm.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTimes } from "@fortawesome/free-solid-svg-icons";
// import axios from "axios";

// const HomeCleanOrderForm = ({ user, formData, onClose, serviceId }) => {
//   const [orderData, setOrderData] = useState({
//     city: user?.city || "",
//     address: user?.Address || "",
//     mobile: user?.mobile || "",
//   });
//   const [showSuccessPopup, setShowSuccessPopup] = useState(false);
//   const [showForm, setShowForm] = useState(true);
//   const [showBlockedPopup, setShowBlockedPopup] = useState(false);

//   // Compute penalty and final price (base price + penalty)
//   const penalty = user && user.penalty ? Number(user.penalty) : 0;
//   console.log("use penalty", penalty);
//   const basePrice = Number(formData.price) || 0;
//   const finalPrice = user.penaltyReserved
//     ? basePrice
//     : basePrice + (user.penalty ? Number(user.penalty) : 0);

//   // useEffect(() => {
//   //   if (user) {
//   //     setOrderData({
//   //       city: user.city || "",
//   //       address: user.Address || "",
//   //       mobile: user.mobile || "",
//   //     });
//   //   }
//   // }, [user]);

//   useEffect(() => {
//       if (user) {
//         // Added: Check if user status is "Blocked"
//         if (user.status === "Blocked") {
//           setShowBlockedPopup(true);
//           setShowForm(false); // Prevent form from showing
//         } else {
//           setOrderData({
//             city: user.city || "",
//             address: user.Address || "",
//             mobile: user.mobile || "",
//           });
//         }
//       }
//     }, [user]);

//   // Disable background scroll when modal is open
//     useEffect(() => {
//       document.body.style.overflow = 'hidden';
//       return () => {
//         document.body.style.overflow = 'auto';
//       };
//     }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setOrderData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   const formatDate = (dateStr) => {
//     const dateObj = new Date(dateStr);
//     const day = dateObj.getDate();
//     const month = dateObj.toLocaleString('default', { month: 'short' });
//     const year = dateObj.getFullYear();
//     return `${day}-${month}-${year}`;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const finalOrderData = {
//       userId: user.Id, // Assuming `user.Id` contains the user's ID
//       usercity: orderData.city,
//       useraddress: orderData.address,
//       bed: formData.bedrooms,
//       bath: formData.bathrooms,
//       dra_din: formData.drawingdinning,
//       kitchen: formData.kitchens,
//       cloth: formData.cloths,
//       dish: formData.dishes,
//       price: formData.price,
//       // price: finalPrice,
//       date: formData.date,
//       time: formData.time,
//       status: "pending", // Set an initial status
//       servitor_id: 0, // Assuming 0 for now, you might want to get this dynamically
//       serviceId: 2, // Adding the serviceId here
//     };

//     try {
//       const response = await axios.post(
//         "http://localhost:4001/homeclean",
//         finalOrderData
//       );
//       console.log("Order placed successfully:", response.data);
//       // onClose();
//       setShowForm(false);
//       setShowSuccessPopup(true);
//     } catch (error) {
//       console.error("Error placing order:", error);
//     }
//   };

//   const closePopup = () => {
//     setShowSuccessPopup(false);
//     onClose();
//   };

//   // Handler for closing the blocked popup
//   const closeBlockedPopup = () => {
//     setShowBlockedPopup(false);
//     onClose();
//   };

//   return (
//     <>
//       {showForm && (
//         <div className="homecleanorder-modal">
//           <div className="homecleanorder-overlay" onClick={onClose}></div>
//           <div className="homecleanorder-form-container">
//             <div className="homecleanorder-form-header">
//               <div className="header-content">
//                 <h2>Order Details</h2>
//               </div>
//               <button className="close-button" onClick={onClose}>
//                 <FontAwesomeIcon icon={faTimes} />
//               </button>
//             </div>
//             <hr />
//             <div className="homecleanorder-form-content">
//               <div className="homecleanorder-left">
//                 <div className="homecleanorder-row">
//                   <div className="homecleanorder-col">
//                     <label>Name</label>
//                     <input
//                       type="text"
//                       value={`${user.FirstName} ${user.LastName}`}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="homecleanorder-row">
//                   <div className="homecleanorder-col">
//                     <label>Mobile</label>
//                     <input
//                       type="text"
//                       value={"0" + orderData.mobile}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="homecleanorder-row">
//                   <div className="homecleanorder-col">
//                     <label>City</label>
//                     <select
//                       id="city"
//                       name="city"
//                       value={orderData.city}
//                       onChange={handleChange}
//                     >
//                       <option value="">Select your City</option>
//                       <option value="Dhaka">Dhaka</option>
//                       <option value="Chattogram">Chattogram</option>
//                       <option value="Barishal">Barishal</option>
//                       <option value="Sylhet">Sylhet</option>
//                       <option value="Rajshahi">Rajshahi</option>
//                       <option value="Khulna">Khulna</option>
//                       <option value="Rangpur">Rangpur</option>
//                       <option value="Maymensingh">Maymensingh</option>
//                     </select>
//                   </div>
//                 </div>
//                 <div className="homecleanorder-row">
//                   <div className="homecleanorder-col">
//                     <label>Address</label>
//                     <input
//                       type="text"
//                       name="address"
//                       value={orderData.address}
//                       onChange={handleChange}
//                     />
//                   </div>
//                 </div>
//               </div>
//               <div className="homecleanorder-right">
//                 <div className="homecleanorder-row">
//                   <div className="homecleanorder-col">
//                     <label>Bedroom</label>
//                     <input type="text" value={formData.bedrooms} readOnly />
//                   </div>
//                   <div className="homecleanorder-col">
//                     <label>Bathroom</label>
//                     <input type="text" value={formData.bathrooms} readOnly />
//                   </div>
//                   <div className="homecleanorder-col">
//                     <label>Drawing-Dinning</label>
//                     <input
//                       type="text"
//                       value={formData.drawingdinning}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="homecleanorder-row">
//                   <div className="homecleanorder-col">
//                     <label>Kitchen</label>
//                     <input type="text" value={formData.kitchens} readOnly />
//                   </div>
//                   <div className="homecleanorder-col">
//                     <label>Cloth Cleaning</label>
//                     <input type="text" value={formData.cloths} readOnly />
//                   </div>
//                   <div className="homecleanorder-col">
//                     <label>Dish Cleaning</label>
//                     <input type="text" value={formData.dishes} readOnly />
//                   </div>
//                 </div>
//                 <div className="homecleanorder-row">
//                   <div className="homecleanorder-col">
//                     <label>Date</label>
//                     <input type="text" value={formatDate(formData.date)} readOnly />
//                   </div>
//                   <div className="homecleanorder-col">
//                     <label>Time</label>
//                     <input type="text" value={formData.time} readOnly />
//                   </div>
//                 </div>
//                 {/* <div className="homecleanorder-row">
//                             <div className="homecleanorder-col">
//                                 <label>Total Price</label>
//                                 <input type="text" value={`${formData.price} tk`} readOnly />
//                                 <input type="text" value={`${finalPrice} tk`} readOnly />
//                             </div>
//                         </div> */}
//                 <div className="homecleanorder-row">
//                   {!user.penaltyReserved && penalty > 0 ? (
//                     <>
//                       <div className="homecleanorder-col">
//                         <label>Base Price</label>
//                         <input type="text" value={`${basePrice} tk`} readOnly />
//                       </div>
//                       <div className="homecleanorder-col">
//                         <label>Penalty</label>
//                         <input type="text" value={`${penalty} tk`} readOnly />
//                       </div>
//                       <div className="homecleanorder-col">
//                         <label>Total Price</label>
//                         <input
//                           type="text"
//                           value={`${finalPrice} tk`}
//                           readOnly
//                         />
//                       </div>
//                     </>
//                   ) : (
//                     <div className="homecleanorder-col">
//                       <label>Total Price</label>
//                       <input type="text" value={`${finalPrice} tk`} readOnly />
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//             <div className="homecleanorder-button-container">
//               <button
//                 type="submit"
//                 className="homecleanorder-button"
//                 onClick={handleSubmit}
//               >
//                 Place Order
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//       {showSuccessPopup && (
//         <div className="homecleanorder-success-popup">
//           <div className="homecleanorder-success-popup-content">
//             <h2>Order successfully placed!</h2>
//             <p>Thank you</p>
//             <p>Stay with HelpNao</p>
//             <button onClick={closePopup}>Ok</button>
//           </div>
//         </div>
//       )}

//       {showBlockedPopup && (
//         <div className="homecleanorder-success-popup">
//           <div className="homecleanorder-success-popup-content">
//             <h2>Account Blocked</h2>
//             <p>Your account is blocked due to excessive cancellations.</p>
//             <p>Please contact our support team for assistance.</p>
//             <button onClick={closeBlockedPopup}>Close</button>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default HomeCleanOrderForm;

// ***************** New update with new design and features - All okay checked (19-6-25)****************** //

// import React, { useState, useEffect } from "react";
// import "./homecleanOrderForm.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faTimes,
//   faUser,
//   faCalendarAlt,
//   faTools,
//   faHome,
//   faSprayCan,
//   faBroom,
// } from "@fortawesome/free-solid-svg-icons";
// import axios from "axios";

// const HomeCleanOrderForm = ({ user, formData, onClose, serviceId }) => {
//   const [orderData, setOrderData] = useState({
//     city: user?.city || "",
//     address: user?.Address || "",
//     mobile: user?.mobile || "",
//   });
//   const [showSuccessPopup, setShowSuccessPopup] = useState(false);
//   const [showForm, setShowForm] = useState(true);
//   const [showBlockedPopup, setShowBlockedPopup] = useState(false);

//   const penalty = user && user.penalty ? Number(user.penalty) : 0;
//   const basePrice = Number(formData.price) || 0;
//   const finalPrice = user.penaltyReserved ? basePrice : basePrice + penalty;

//   useEffect(() => {
//     if (user) {
//       if (user.status === "Blocked") {
//         setShowBlockedPopup(true);
//         setShowForm(false);
//       } else {
//         setOrderData({
//           city: user.city || "",
//           address: user.Address || "",
//           mobile: user.mobile || "",
//         });
//       }
//     }
//   }, [user]);

//   useEffect(() => {
//     document.body.style.overflow = "hidden";
//     return () => {
//       document.body.style.overflow = "auto";
//     };
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setOrderData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   const formatDate = (dateStr) => {
//     const dateObj = new Date(dateStr);
//     const day = dateObj.getDate();
//     const month = dateObj.toLocaleString("default", { month: "short" });
//     const year = dateObj.getFullYear();
//     return `${day}-${month}-${year}`;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const finalOrderData = {
//       userId: user.Id,
//       usercity: orderData.city,
//       useraddress: orderData.address,
//       bed: formData.bedrooms,
//       bath: formData.bathrooms,
//       dra_din: formData.drawingdinning,
//       kitchen: formData.kitchens,
//       cloth: formData.cloths,
//       dish: formData.dishes,

//       balcony: formData.balconies, // ← new
//       window_grill: formData.windowGrills, // ← new
//       furniture_cleaning: formData.furniture, // ← new

//       price: formData.price,
//       // price: finalPrice,
//       date: formData.date,
//       time: formData.time,
//       status: "pending",
//       servitor_id: 0,
//       serviceId: 2,
//     };

//     try {
//       const response = await axios.post(
//         "http://localhost:4001/homeclean",
//         finalOrderData
//       );
//       console.log("Order placed successfully:", response.data);
//       setShowForm(false);
//       setShowSuccessPopup(true);
//     } catch (error) {
//       console.error("Error placing order:", error);
//     }
//   };

//   const closePopup = () => {
//     setShowSuccessPopup(false);
//     onClose();
//   };

//   const closeBlockedPopup = () => {
//     setShowBlockedPopup(false);
//     onClose();
//   };

//   return (
//     <>
//       {showForm && (
//         <div className="homecleanorder-modal-backdrop">
//           <div className="homecleanorder-modal-content">
//             <div className="homecleanorder-modal-header">
//               <h2 className="homecleanorder-modal-title">
//                 Home Cleaning Order
//               </h2>
//               <button className="homecleanorder-modal-close" onClick={onClose}>
//                 <FontAwesomeIcon icon={faTimes} />
//               </button>
//             </div>

//             <div className="homecleanorder-modal-body">
//               <div className="homecleanorder-two-column-grid">
//                 {/* Customer Information Card */}
//                 <div className="homecleanorder-modal-card">
//                   <div className="homecleanorder-card-body">
//                     <h3 className="homecleanorder-card-title">
//                       <FontAwesomeIcon icon={faUser} /> Customer Information
//                     </h3>
//                     <div className="homecleanorder-form-grid">
//                       <div className="homecleanorder-form-group">
//                         <label className="homecleanorder-form-label">
//                           Name
//                         </label>
//                         <input
//                           type="text"
//                           className="homecleanorder-form-control"
//                           value={`${user.FirstName} ${user.LastName}`}
//                           readOnly
//                         />
//                       </div>
//                       <div className="homecleanorder-form-group">
//                         <label className="homecleanorder-form-label">
//                           Mobile
//                         </label>
//                         <input
//                           type="text"
//                           className="homecleanorder-form-control"
//                           value={`0${orderData.mobile}`}
//                           readOnly
//                         />
//                       </div>
//                       <div className="homecleanorder-form-group">
//                         <label className="homecleanorder-form-label">
//                           City
//                         </label>
//                         <select
//                           name="city"
//                           className="homecleanorder-form-control"
//                           value={orderData.city}
//                           onChange={handleChange}
//                         >
//                           <option value="">Select your City</option>
//                           <option value="Dhaka">Dhaka</option>
//                           <option value="Chattogram">Chattogram</option>
//                           <option value="Barishal">Barishal</option>
//                           <option value="Sylhet">Sylhet</option>
//                           <option value="Rajshahi">Rajshahi</option>
//                           <option value="Khulna">Khulna</option>
//                           <option value="Rangpur">Rangpur</option>
//                           <option value="Maymensingh">Maymensingh</option>
//                         </select>
//                       </div>
//                       <div className="homecleanorder-form-group">
//                         <label className="homecleanorder-form-label">
//                           Address
//                         </label>
//                         <textarea
//                           name="address"
//                           className="homecleanorder-form-control"
//                           rows="3"
//                           value={orderData.address}
//                           onChange={handleChange}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Booking Details Card */}
//                 <div className="homecleanorder-modal-card">
//                   <div className="homecleanorder-card-body">
//                     <h3 className="homecleanorder-card-title">
//                       <FontAwesomeIcon icon={faCalendarAlt} /> Booking Details
//                     </h3>
//                     <div className="homecleanorder-form-grid">
//                       <div className="homecleanorder-form-group">
//                         <label className="homecleanorder-form-label">
//                           Date
//                         </label>
//                         <input
//                           type="text"
//                           className="homecleanorder-form-control"
//                           value={formatDate(formData.date)}
//                           readOnly
//                         />
//                       </div>
//                       <div className="homecleanorder-form-group">
//                         <label className="homecleanorder-form-label">
//                           Time
//                         </label>
//                         <input
//                           type="text"
//                           className="homecleanorder-form-control"
//                           value={formData.time}
//                           readOnly
//                         />
//                       </div>
//                       {!user.penaltyReserved && penalty > 0 ? (
//                         <>
//                           <div className="homecleanorder-form-group">
//                             <label className="homecleanorder-form-label">
//                               Base Price
//                             </label>
//                             <input
//                               type="text"
//                               className="homecleanorder-form-control"
//                               value={`${basePrice} tk`}
//                               readOnly
//                             />
//                           </div>
//                           <div className="homecleanorder-form-group">
//                             <label className="homecleanorder-form-label">
//                               Penalty
//                             </label>
//                             <input
//                               type="text"
//                               className="homecleanorder-form-control"
//                               value={`${penalty} tk`}
//                               readOnly
//                             />
//                           </div>
//                           <div className="homecleanorder-form-group">
//                             <label className="homecleanorder-form-label">
//                               Total Price
//                             </label>
//                             <input
//                               type="text"
//                               className="homecleanorder-form-control homecleanorder-total-price"
//                               value={`${finalPrice} tk`}
//                               readOnly
//                             />
//                           </div>
//                         </>
//                       ) : (
//                         <div className="homecleanorder-form-group">
//                           <label className="homecleanorder-form-label">
//                             Total Price
//                           </label>
//                           <input
//                             type="text"
//                             className="homecleanorder-form-control homecleanorder-total-price"
//                             value={`${finalPrice} tk`}
//                             readOnly
//                           />
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Service Details Card */}
//               <div className="homecleanorder-modal-card">
//                 <div className="homecleanorder-card-body">
//                   <h3 className="homecleanorder-card-title">
//                     {/* <FontAwesomeIcon icon={faBroom} /> Service Details */}
//                     {/* <FontAwesomeIcon icon={faTools} /> Service Details */}
//                      Service Details
//                   </h3>
//                   <div className="homecleanorder-services-section">
//                     {/* Core Cleaning */}
//                     <div className="homecleanorder-service-category">
//                       <h4 className="homecleanorder-category-header">
//                         {/* <i className="fas fa-home"></i> Core Room Cleaning */}
//                         <FontAwesomeIcon icon={faHome} /> Core Room Cleaning
//                       </h4>
//                       <div className="homecleanorder-services-grid">
//                         <div className="homecleanorder-service-item">
//                           <label className="homecleanorder-form-label">
//                             Bedrooms
//                           </label>
//                           <div
//                             className={`homecleanorder-service-value ${
//                               formData.bedrooms > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.bedrooms}{" "}
//                             <span className="homecleanorder-service-unit">
//                               units
//                             </span>
//                           </div>
//                         </div>

//                         <div className="homecleanorder-service-item">
//                           <label className="homecleanorder-form-label">
//                             Kitchens
//                           </label>
//                           <div
//                             className={`homecleanorder-service-value ${
//                               formData.kitchens > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.kitchens}{" "}
//                             <span className="homecleanorder-service-unit">
//                               units
//                             </span>
//                           </div>
//                         </div>

//                         <div className="homecleanorder-service-item">
//                           <label className="homecleanorder-form-label">
//                             Drawing-Dining
//                           </label>
//                           <div
//                             className={`homecleanorder-service-value ${
//                               formData.drawingdinning > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.drawingdinning}{" "}
//                             <span className="homecleanorder-service-unit">
//                               units
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Specialized Cleaning */}
//                     <div className="homecleanorder-service-category">
//                       <h4 className="homecleanorder-category-header">
//                         {/* <i className="fas fa-spray-can"></i> Specialized */}
//                         <FontAwesomeIcon icon={faSprayCan} /> Specialized
//                         Cleaning
//                       </h4>
//                       <div className="homecleanorder-services-grid">
//                         <div className="homecleanorder-service-item">
//                           <label className="homecleanorder-form-label">
//                             Bathrooms
//                           </label>
//                           <div
//                             className={`homecleanorder-service-value ${
//                               formData.bathrooms > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.bathrooms}{" "}
//                             <span className="homecleanorder-service-unit">
//                               units
//                             </span>
//                           </div>
//                         </div>

//                         <div className="homecleanorder-service-item">
//                           <label className="homecleanorder-form-label">
//                             Balcony Cleaning
//                           </label>
//                           <div
//                             className={`homecleanorder-service-value ${
//                               formData.balconies > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.balconies}{" "}
//                             <span className="homecleanorder-service-unit">
//                               units
//                             </span>
//                           </div>
//                         </div>
//                         <div className="homecleanorder-service-item">
//                           <label className="homecleanorder-form-label">
//                             Window & Grill Cleaning
//                           </label>
//                           <div
//                             className={`homecleanorder-service-value ${
//                               formData.windowGrills > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.windowGrills}{" "}
//                             <span className="homecleanorder-service-unit">
//                               units
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Kitchen & Laundry */}
//                     <div className="homecleanorder-service-category">
//                       <h4 className="homecleanorder-category-header">
//                         {/* <i className="fas fa-broom"></i> Additional Services */}
//                         <FontAwesomeIcon icon={faBroom} /> Additional Services
//                       </h4>
//                       <div className="homecleanorder-services-grid">
//                         <div className="homecleanorder-service-item">
//                           <label className="homecleanorder-form-label">
//                             Furniture Cleaning
//                           </label>
//                           <div
//                             className={`homecleanorder-service-value ${
//                               formData.furniture > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.furniture}{" "}
//                             <span className="homecleanorder-service-unit">
//                               units
//                             </span>
//                           </div>
//                         </div>
//                         <div className="homecleanorder-service-item">
//                           <label className="homecleanorder-form-label">
//                             Cloth Cleaning
//                           </label>
//                           <div
//                             className={`homecleanorder-service-value ${
//                               formData.cloths > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.cloths}{" "}
//                             <span className="homecleanorder-service-unit">
//                               units
//                             </span>
//                           </div>
//                         </div>
//                         <div className="homecleanorder-service-item">
//                           <label className="homecleanorder-form-label">
//                             Dish Cleaning
//                           </label>
//                           <div
//                             className={`homecleanorder-service-value ${
//                               formData.dishes > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.dishes}{" "}
//                             <span className="homecleanorder-service-unit">
//                               units
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="homecleanorder-order-actions">
//               <button
//                 className="homecleanorder-btn homecleanorder-btn-outline"
//                 onClick={onClose}
//               >
//                 Cancel
//               </button>
//               <button
//                 className="homecleanorder-btn homecleanorder-btn-primary"
//                 onClick={handleSubmit}
//               >
//                 <FontAwesomeIcon icon={faTools} /> Place Order
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {showSuccessPopup && (
//         <div className="homecleanorder-success-popup">
//           <div className="homecleanorder-success-popup-content">
//             <h2>Order Successfully Placed!</h2>
//             <p>Thank you for choosing HelpNao.</p>
//             <p>Your order is now pending confirmation.</p>
//             <button
//               className="homecleanorder-btn homecleanorder-btn-primary"
//               onClick={closePopup}
//             >
//               Ok
//             </button>
//           </div>
//         </div>
//       )}

//       {showBlockedPopup && (
//         <div className="homecleanorder-success-popup">
//           <div className="homecleanorder-success-popup-content">
//             <h2>Account Blocked</h2>
//             <p>Your account is blocked due to excessive cancellations.</p>
//             <p>Please contact our support team for assistance.</p>
//             <button
//               className="homecleanorder-btn homecleanorder-btn-primary"
//               onClick={closeBlockedPopup}
//             >
//               Close
//             </button>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default HomeCleanOrderForm;

// ***** Upper Codes All okay and checked (19-6-25) ***** //







// ***** New added Translate EN-BN (19-6-25) ***** //

import React, { useState, useEffect, useRef } from "react";
import "./homecleanOrderForm.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes,
  faUser,
  faCalendarAlt,
  faTools,
  faHome,
  faSprayCan,
  faBroom,
  faCommentAlt,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { URL } from "../../../config";

// const API_BASE = "http://localhost:4001";

const HomeCleanOrderForm = ({
  user,
  formData,
  onClose,
  onSubmit,
  previousServitorName,
  serviceId,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // locations
  const [divisions, setDivisions] = useState([]); // [{Id,name,code}]
  const [areas, setAreas] = useState([]);         // [{Id,name}]
  const [selectedDivisionId, setSelectedDivisionId] = useState(null);
  const [selectedAreaId, setSelectedAreaId] = useState(null);

  // Refs for first invalid field focus
  const divisionRef = useRef(null);
  const areaRef = useRef(null);
  const addressRef = useRef(null);

  const [orderData, setOrderData] = useState({
    city: user?.city || "",
    address: user?.Address || "",
    mobile: user?.mobile || "",
  });
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showForm, setShowForm] = useState(true);
  const [showBlockedPopup, setShowBlockedPopup] = useState(false);

  const [errors, setErrors] = useState({ city: "", area: "", address: "" });

  // For coupons
  const [couponCode, setCouponCode] = useState("");
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [couponError, setCouponError] = useState("");
  const [isApplyingCoupon, setIsApplyingCoupon] = useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const penalty = user && user.penalty ? Number(user.penalty) : 0;
  const basePrice = Number(formData.price) || 0;
  // const finalPrice = user.penaltyReserved ? basePrice : basePrice + penalty;

  const [discountValue, setDiscountValue] = useState(0);
  
  const finalPrice = (() => {
    const total = user.penaltyReserved ? basePrice : basePrice + penalty;
    return Math.max(0, total - discountValue);
  })();

  useEffect(() => {
    if (user) {
      if (user.status === "Blocked") {
        setShowBlockedPopup(true);
        setShowForm(false);
      } else {
        setOrderData({
          // city: user.city || "",
          address: user.Address || "",
          mobile: user.mobile || "",
        });
      }
    }
  }, [user]);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);


  // load active divisions, preselect by user.city
  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${URL}/locations/divisions`, { params: { countryCode: "BD" } });
        setDivisions(data || []);
        if (user?.city) {
          const match = (data || []).find(d => d.name.toLowerCase() === String(user.city).toLowerCase());
          if (match) setSelectedDivisionId(match.Id);
        }
      } catch (e) {
        console.error("Failed to load divisions:", e);
        setDivisions([]);
      }
    })();
  }, [user?.city]);

  // load areas when division changes, preselect by user.area
  useEffect(() => {
    (async () => {
      if (!selectedDivisionId) {
        setAreas([]);
        setSelectedAreaId(null);
        return;
      }
      try {
        const { data } = await axios.get(`${URL}/locations/areas`, { params: { divisionId: selectedDivisionId } });
        setAreas(data || []);
        if (user?.area) {
          const match = (data || []).find(a => a.name.toLowerCase() === String(user.area).toLowerCase());
          setSelectedAreaId(match ? match.Id : null);
        } else {
          setSelectedAreaId(null);
        }
      } catch (e) {
        console.error("Failed to load areas:", e);
        setAreas([]);
        setSelectedAreaId(null);
      }
    })();
  }, [selectedDivisionId, user?.area]);

  // handlers
  const handleDivisionChange = (e) => {
    const id = e.target.value ? Number(e.target.value) : null;
    setSelectedDivisionId(id);
    setErrors(prev => ({ ...prev, city: "" }));
  };
  const handleAreaChange = (e) => {
    const id = e.target.value ? Number(e.target.value) : null;
    setSelectedAreaId(id);
    setErrors(prev => ({ ...prev, area: "" }));
  };
  const handleAddressChange = (e) => {
    const value = e.target.value;
    setOrderData(prev => ({ ...prev, address: value }));
    if (value?.trim()) setErrors(prev => ({ ...prev, address: "" }));
  };

  // validate inline
  const validate = () => {
    const errs = { city: "", area: "", address: "" };
    if (!selectedDivisionId) errs.city = t("Please select your city");
    if (!selectedAreaId) errs.area = t("Please select your area");
    if (!orderData.address?.trim()) errs.address = t("Please enter your address");
    setErrors(errs);
    return !errs.city && !errs.area && !errs.address;
  };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setOrderData((prevData) => ({
  //     ...prevData,
  //     [name]: value,
  //   }));
  // };

  const formatDate = (dateStr) => {
    const dateObj = new Date(dateStr);
    const day = dateObj.getDate();
    const month = dateObj.toLocaleString("default", { month: "short" });
    const year = dateObj.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    if (!validate()) {
      // focus + scroll to the first invalid
      if (!selectedDivisionId && divisionRef.current) {
        divisionRef.current.focus();
        divisionRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      } else if (!selectedAreaId && areaRef.current) {
        areaRef.current.focus();
        areaRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      } else if (!orderData.address?.trim() && addressRef.current) {
        addressRef.current.focus();
        addressRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      return;
    }

    const selectedDivision = divisions.find(d => d.Id === selectedDivisionId);
    const selectedArea = areas.find(a => a.Id === selectedAreaId);

    const finalOrderData = {
      userId: user.Id,
      usercity: selectedDivision?.name || "",
      userarea: selectedArea?.name || "",       
      useraddress: orderData.address,

      bed: formData.bedrooms,
      bath: formData.bathrooms,
      dra_din: formData.drawingdinning,
      kitchen: formData.kitchens,
      cloth: formData.cloths,
      dish: formData.dishes,

      balcony: formData.balconies,
      window_grill: formData.windowGrills,
      furniture_cleaning: formData.furniture,
      stairs_and_railing: formData.stairsFloors,
      carpet_cleaning: formData.carpets,

      remarks: formData.remarks,

      // price: formData.price,
      price: finalPrice,

      date: formData.date,
      time: formData.time,
      status: "pending",

      // rebook
      servitor_id: formData.useSameServitor ? formData.servitor_id : 0,
      useSameServitor: formData.useSameServitor,
      previousServitorId: formData.servitor_id,

      serviceId: serviceId || 2,
    };

    if (appliedCoupon) {
      finalOrderData.appliedCoupon = appliedCoupon;
      finalOrderData.discountValue = discountValue;
    }

    try {
      setIsSubmitting(true);

      await axios.post(`${URL}/homeclean`, finalOrderData);
      setShowForm(false);
      setShowSuccessPopup(true);
    } catch (error) {
      console.error("Error placing order:", error);
    } finally {
      setIsSubmitting(false);
    }
  };


  // === Coupon handling ===
    const handleApplyCoupon = async () => {
      if (!couponCode.trim()) {
        setCouponError("Please enter a coupon code.");
        return;
      }
      setIsApplyingCoupon(true);
      setCouponError("");
      try {
        const res = await axios.post(`${URL}/usercoupon/apply`, {
          userId: user.Id,
          code: couponCode.trim(),
        });
        const { discountValue, code } = res.data;
        setAppliedCoupon(code);
        setDiscountValue(discountValue);
        setCouponError("");
      } catch (err) {
        setAppliedCoupon(null);
        setDiscountValue(0);
        setCouponError(err?.response?.data?.message || "Invalid or expired coupon.");
      } finally {
        setIsApplyingCoupon(false);
      }
    };
  
    const handleRemoveCoupon = async () => {
      // try {
      //   await axios.post(`${URL}/usercoupon/remove`, {
      //     userId: user.Id,
      //     code: appliedCoupon,
      //   });
      // } catch (err) {
      //   console.warn("Coupon removal failed (non-blocking):", err);
      // }
      setAppliedCoupon(null);
      setDiscountValue(0);
      setCouponCode("");
      setCouponError("");
    };
  

  const closePopup = () => {
    setShowSuccessPopup(false);
    onClose();
    onSubmit();
    navigate("/profile/orderhistory");
  };

  const closeBlockedPopup = () => {
    setShowBlockedPopup(false);
    onClose();
  };

  return (
    <>
      {showForm && (
        <div className="homecleanorder-modal-backdrop">
          <div className="homecleanorder-modal-content">
            <div className="homecleanorder-modal-header">
              <h2 className="homecleanorder-modal-title">
                {/* Home Cleaning Order */}
                {t("homecleanorderform.order_form.modal.title")}{" "}
                {/* CHANGED: Added translation */}
              </h2>
              <button
                className="homecleanorder-modal-close"
                onClick={onClose}
                aria-label={t(
                  "homecleanorderform.order_form.modal.close_button"
                )}
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>

            <div className="homecleanorder-modal-body">
              <div className="homecleanorder-two-column-grid">
                <div className="homecleanorder-modal-card">
                  <div className="homecleanorder-card-body">
                    <h3 className="homecleanorder-card-title">
                      <FontAwesomeIcon icon={faUser} />
                      {/* Customer Information */}
                      {t(
                        "homecleanorderform.order_form.customer_information.title"
                      )}{" "}
                      {/* CHANGED: Added translation */}
                    </h3>
                    <div className="homecleanorder-form-grid">
                      <div className="homecleanorder-form-group">
                        <label className="homecleanorder-form-label">
                          {/* Name */}
                          {t(
                            "homecleanorderform.order_form.customer_information.labels.name"
                          )}{" "}
                          {/* CHANGED: Added translation */}
                        </label>
                        <input
                          type="text"
                          className="homecleanorder-form-control"
                          value={`${user.FirstName} ${user.LastName}`}
                          readOnly
                        />
                      </div>
                      <div className="homecleanorder-form-group">
                        <label className="homecleanorder-form-label">
                          {/* Mobile */}
                          {t(
                            "homecleanorderform.order_form.customer_information.labels.mobile"
                          )}{" "}
                          {/* CHANGED: Added translation */}
                        </label>
                        <input
                          type="text"
                          className="homecleanorder-form-control"
                          value={`${orderData.mobile}`}
                          readOnly
                        />
                      </div>
                      <div className="homecleanorder-form-group">
                        <label className="homecleanorder-form-label">
                          {/* City */}
                          {t(
                            "homecleanorderform.order_form.customer_information.labels.city"
                          )}{" "}
                          {/* CHANGED: Added translation */}
                        </label>
                        <select
                          className={`homecleanorder-form-control ${errors.city ? "hc-error" : ""}`}
                          value={selectedDivisionId || ""}
                          onChange={handleDivisionChange}
                          onBlur={validate}
                          ref={divisionRef}
                        >
                          <option value="">
                            {t("plumberorderform.order_form.customer_information.labels.city_placeholder")}
                          </option>
                          {divisions.map(d => (
                            <option key={d.Id} value={d.Id}>{d.name}</option>
                          ))}
                        </select>
                        {errors.city && <small className="hc-error-text">{errors.city}</small>}
                      </div>

                      {/* Area */}
                      <div className="homecleanorder-form-group">
                        <label className="homecleanorder-form-label">
                          {t("homecleanorderform.order_form.customer_information.labels.area", "Area")}
                        </label>
                        <select
                          className={`homecleanorder-form-control ${errors.area ? "hc-error" : ""}`}
                          value={selectedAreaId || ""}
                          onChange={handleAreaChange}
                          onBlur={validate}
                          ref={areaRef}
                          disabled={!selectedDivisionId}
                        >
                          <option value="">
                            {!selectedDivisionId ? t("Select City first") : t("Select Area")}
                          </option>
                          {areas.map(a => (
                            <option key={a.Id} value={a.Id}>{a.name}</option>
                          ))}
                        </select>
                        {errors.area && <small className="hc-error-text">{errors.area}</small>}
                      </div>

                      <div className="homecleanorder-form-group">
                        <label className="homecleanorder-form-label">
                          {/* Address */}
                          {t(
                            "homecleanorderform.order_form.customer_information.labels.address"
                          )}{" "}
                          {/* CHANGED: Added translation */}
                        </label>
                        <textarea
                          className={`homecleanorder-form-control ${errors.address ? "hc-error" : ""}`}
                          rows="3"
                          value={orderData.address}
                          onChange={handleAddressChange}
                          onBlur={validate}
                          ref={addressRef}
                        />
                        {errors.address && <small className="hc-error-text">{errors.address}</small>}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="homecleanorder-modal-card">
                  <div className="homecleanorder-card-body">
                    <h3 className="homecleanorder-card-title">
                      <FontAwesomeIcon icon={faCalendarAlt} />
                      {/* Booking Details */}
                      {t(
                        "homecleanorderform.order_form.booking_details.title"
                      )}{" "}
                      {/* CHANGED: Added translation */}
                    </h3>
                    <div className="homecleanorder-form-grid">
                      <div className="homecleanorder-form-group">
                        <label className="homecleanorder-form-label">
                          {/* Date */}
                          {t(
                            "homecleanorderform.order_form.booking_details.labels.date"
                          )}{" "}
                          {/* CHANGED: Added translation */}
                        </label>
                        <input
                          type="text"
                          className="homecleanorder-form-control"
                          value={formatDate(formData.date)}
                          readOnly
                        />
                      </div>
                      <div className="homecleanorder-form-group">
                        <label className="homecleanorder-form-label">
                          {/* Time */}
                          {t(
                            "homecleanorderform.order_form.booking_details.labels.time"
                          )}{" "}
                          {/* CHANGED: Added translation */}
                        </label>
                        <input
                          type="text"
                          className="homecleanorder-form-control"
                          value={formData.time}
                          readOnly
                        />
                      </div>
                      {!user.penaltyReserved && penalty > 0 ? (
                        <>
                          <div className="homecleanorder-form-group">
                            <label className="homecleanorder-form-label">
                              {/* Base Price */}
                              {t(
                                "homecleanorderform.order_form.booking_details.labels.base_price"
                              )}{" "}
                              {/* CHANGED: Added translation */}
                            </label>
                            <input
                              type="text"
                              className="homecleanorder-form-control"
                              value={`${basePrice} tk`}
                              readOnly
                            />
                          </div>
                          <div className="homecleanorder-form-group">
                            <label className="homecleanorder-form-label">
                              {/* Penalty */}
                              {t(
                                "homecleanorderform.order_form.booking_details.labels.penalty"
                              )}{" "}
                              {/* CHANGED: Added translation */}
                            </label>
                            <input
                              type="text"
                              className="homecleanorder-form-control homecleanorder-penalty-field"
                              value={`${penalty} tk`}
                              readOnly
                            />
                          </div>
                          <div className="homecleanorder-form-group">
                            <label className="homecleanorder-form-label">
                              {/* Total Price */}
                              {t(
                                "homecleanorderform.order_form.booking_details.labels.total_price"
                              )}{" "}
                              {/* CHANGED: Added translation */}
                            </label>
                            <input
                              type="text"
                              className="homecleanorder-form-control homecleanorder-total-price"
                              value={`${finalPrice} tk`}
                              readOnly
                            />
                          </div>
                        </>
                      ) : (
                        // <div className="homecleanorder-form-group">
                        //   <label className="homecleanorder-form-label">
                        //     {t(
                        //       "homecleanorderform.order_form.booking_details.labels.total_price"
                        //     )}{" "}
                        //   </label>
                        //   <input
                        //     type="text"
                        //     className="homecleanorder-form-control homecleanorder-total-price"
                        //     value={`${finalPrice} tk`}
                        //     readOnly
                        //   />
                        // </div>

                        // New design for dicount
                        <div className="electricianorder-form-group">
                        <label className="electricianorder-form-label">
                          {t("electricianorderform.order_form.booking_details.labels.total_price")}
                        </label>

                        {appliedCoupon ? (
                          <div className="electricianorder-price-discounted">
                            <div className="electricianorder-original-price">
                              {user.penaltyReserved
                                ? `${basePrice} tk`
                                : `${basePrice + penalty} tk`}
                            </div>

                            <div className="electricianorder-final-price">
                              <span className="discounted-price">{finalPrice} tk</span>
                              <small className="discount-label">({discountValue} tk off)</small>
                            </div>
                          </div>
                        ) : (
                          <input
                            type="text"
                            className="electricianorder-form-control electricianorder-total-price"
                            value={`${finalPrice} tk`}
                            readOnly
                          />
                        )}
                      </div>
                      )}

                      {/* Coupon Code */}
                      <div className="electricianorder-form-group">
                        <label className="electricianorder-form-label">
                          {t("electricianorderform.order_form.booking_details.labels.coupon", "Coupon Code")}
                        </label>

                        {appliedCoupon ? (
                          <div className="electricianorder-coupon-applied">
                            {/* <p>
                              ✅ Applied: <strong>{appliedCoupon}</strong>
                            </p> */}
                             <p>
                                ✅ {t("electricianorderform.coupon.applied", "Applied")}:{" "}
                                <strong>{appliedCoupon}</strong>
                              </p>
                            <button
                              type="button"
                              // className="electricianorder-btn electricianorder-btn-outline"
                              className="electricianorder-btn-removecoupon"
                              onClick={handleRemoveCoupon}
                            >
                              {/* Remove */}
                              {t("electricianorderform.coupon.remove", "Remove")}
                            </button>
                          </div>
                        ) : (
                          <div className="electricianorder-coupon-input-row">
                            <input
                              type="text"
                              value={couponCode}
                              onChange={(e) => setCouponCode(e.target.value)}
                              placeholder={t("electricianorderform.order_form.booking_details.labels.coupon_placeholder", "Enter coupon")}
                              className="electricianorder-form-control"
                              disabled={isApplyingCoupon}
                            />
                            <button
                              type="button"
                              // className="electricianorder-btn electricianorder-btn-primary"
                              className="electricianorder-btn-applycoupon"
                              onClick={handleApplyCoupon}
                              disabled={isApplyingCoupon}
                            >
                              {/* {isApplyingCoupon ? "Applying..." : "Apply"} */}
                              {isApplyingCoupon
                                ? t("electricianorderform.coupon.applying", "Applying...")
                                : t("electricianorderform.coupon.apply", "Apply")}
                            </button>
                          </div>
                        )}

                        {/* {couponError && <div className="field-error">{couponError}</div>} */}

                        {couponError && (
                          <div className="field-error">
                            {t("electricianorderform.coupon.invalid", couponError)}
                          </div>
                        )}

                      </div>
                      
                    </div>
                  </div>
                </div>
              </div>

              <div className="homecleanorder-modal-card">
                <div className="homecleanorder-card-body">
                  <h3 className="homecleanorder-card-title">
                    {/* Service Details */}
                    {t(
                      "homecleanorderform.order_form.service_details.title"
                    )}{" "}
                    {/* CHANGED: Added translation */}
                  </h3>
                  <div className="homecleanorder-services-section">
                    <div className="homecleanorder-service-category">
                      <h4 className="homecleanorder-category-header">
                        <FontAwesomeIcon icon={faHome} />
                        {/* Core Room Cleaning */}
                        {t(
                          "homecleanorderform.order_form.service_details.categories.core_room_cleaning.title"
                        )}{" "}
                        {/* CHANGED: Added translation */}
                      </h4>
                      <div className="homecleanorder-services-grid">
                        <div className="homecleanorder-service-item">
                          <label className="homecleanorder-form-label">
                            {/* Bedrooms */}
                            {t(
                              "homecleanorderform.order_form.service_details.categories.core_room_cleaning.labels.bedrooms"
                            )}{" "}
                            {/* CHANGED: Added translation */}
                          </label>
                          <div
                            className={`homecleanorder-service-value ${
                              formData.bedrooms > 0 ? "has-value" : ""
                            }`}
                          >
                            {formData.bedrooms}{" "}
                            <span className="homecleanorder-service-unit">
                              {/* units */}
                              {t(
                                formData.bedrooms === 1
                                  ? "homecleanorderform.order_form.service_details.unit"
                                  : "homecleanorderform.order_form.service_details.units"
                              )}{" "}
                              {/* CHANGED: Added translation for unit/units */}
                            </span>
                          </div>
                        </div>
                        <div className="homecleanorder-service-item">
                          <label className="homecleanorder-form-label">
                            {/* Kitchens */}
                            {t(
                              "homecleanorderform.order_form.service_details.categories.core_room_cleaning.labels.kitchens"
                            )}{" "}
                            {/* CHANGED: Added translation */}
                          </label>
                          <div
                            className={`homecleanorder-service-value ${
                              formData.kitchens > 0 ? "has-value" : ""
                            }`}
                          >
                            {formData.kitchens}{" "}
                            <span className="homecleanorder-service-unit">
                              {/* units */}
                              {t(
                                formData.kitchens === 1
                                  ? "homecleanorderform.order_form.service_details.unit"
                                  : "homecleanorderform.order_form.service_details.units"
                              )}{" "}
                              {/* CHANGED: Added translation for unit/units */}
                            </span>
                          </div>
                        </div>
                        <div className="homecleanorder-service-item">
                          <label className="homecleanorder-form-label">
                            {/* Drawing-Dining */}
                            {t(
                              "homecleanorderform.order_form.service_details.categories.core_room_cleaning.labels.drawing_dining"
                            )}{" "}
                            {/* CHANGED: Added translation */}
                          </label>
                          <div
                            className={`homecleanorder-service-value ${
                              formData.drawingdinning > 0 ? "has-value" : ""
                            }`}
                          >
                            {formData.drawingdinning}{" "}
                            <span className="homecleanorder-service-unit">
                              {/* units */}
                              {t(
                                formData.drawingdinning === 1
                                  ? "homecleanorderform.order_form.service_details.unit"
                                  : "homecleanorderform.order_form.service_details.units"
                              )}{" "}
                              {/* CHANGED: Added translation for unit/units */}
                            </span>
                          </div>
                        </div>

                        <div className="homecleanorder-service-item">
                          <label className="homecleanorder-form-label">
                            {/* Balcony Cleaning */}
                            {t(
                              "homecleanorderform.order_form.service_details.categories.specialized_cleaning.labels.balconies"
                            )}{" "}
                            {/* CHANGED: Added translation */}
                          </label>
                          <div
                            className={`homecleanorder-service-value ${
                              formData.balconies > 0 ? "has-value" : ""
                            }`}
                          >
                            {formData.balconies}{" "}
                            <span className="homecleanorder-service-unit">
                              {/* units */}
                              {t(
                                formData.balconies === 1
                                  ? "homecleanorderform.order_form.service_details.unit"
                                  : "homecleanorderform.order_form.service_details.units"
                              )}{" "}
                              {/* CHANGED: Added translation for unit/units */}
                            </span>
                          </div>
                        </div>
                        
                      </div>
                    </div>

                    <div className="homecleanorder-service-category">
                      <h4 className="homecleanorder-category-header">
                        <FontAwesomeIcon icon={faSprayCan} />
                        {/* Specialized Cleaning */}
                        {t(
                          "homecleanorderform.order_form.service_details.categories.specialized_cleaning.title"
                        )}{" "}
                        {/* CHANGED: Added translation */}
                      </h4>
                      <div className="homecleanorder-services-grid">
                        <div className="homecleanorder-service-item">
                          <label className="homecleanorder-form-label">
                            {/* Bathrooms */}
                            {t(
                              "homecleanorderform.order_form.service_details.categories.specialized_cleaning.labels.bathrooms"
                            )}{" "}
                            {/* CHANGED: Added translation */}
                          </label>
                          <div
                            className={`homecleanorder-service-value ${
                              formData.bathrooms > 0 ? "has-value" : ""
                            }`}
                          >
                            {formData.bathrooms}{" "}
                            <span className="homecleanorder-service-unit">
                              {/* units */}
                              {t(
                                formData.bathrooms === 1
                                  ? "homecleanorderform.order_form.service_details.unit"
                                  : "homecleanorderform.order_form.service_details.units"
                              )}{" "}
                              {/* CHANGED: Added translation for unit/units */}
                            </span>
                          </div>
                        </div>
                        
                        <div className="homecleanorder-service-item">
                          <label className="homecleanorder-form-label">
                            {/* Window & Grill Cleaning */}
                            {t(
                              "homecleanorderform.order_form.service_details.categories.specialized_cleaning.labels.window_grills"
                            )}{" "}
                            {/* CHANGED: Added translation */}
                          </label>
                          <div
                            className={`homecleanorder-service-value ${
                              formData.windowGrills > 0 ? "has-value" : ""
                            }`}
                          >
                            {formData.windowGrills}{" "}
                            <span className="homecleanorder-service-unit">
                              {/* units */}
                              {t(
                                formData.windowGrills === 1
                                  ? "homecleanorderform.order_form.service_details.unit"
                                  : "homecleanorderform.order_form.service_details.units"
                              )}{" "}
                              {/* CHANGED: Added translation for unit/units */}
                            </span>
                          </div>
                        </div>

                        <div className="homecleanorder-service-item">
                          <label className="homecleanorder-form-label">
                            {t(
                              "homecleanorderform.order_form.service_details.categories.specialized_cleaning.labels.stairs_floors_label"
                            )}
                          </label>
                          <div
                            className={`homecleanorder-service-value ${
                              formData.stairsFloors > 0 ? "has-value" : ""
                            }`}
                          >
                            {formData.stairsFloors}{" "}
                            <span className="homecleanorder-service-unit">
                              {formData.stairsFloors === 1
                                ? t(
                                    "homecleanorderform.order_form.service_details.floor_singular"
                                  )
                                : t(
                                    "homecleanorderform.order_form.service_details.floor_plural"
                                  )}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="homecleanorder-service-category">
                      <h4 className="homecleanorder-category-header">
                        <FontAwesomeIcon icon={faBroom} />
                        {/* Additional Services */}
                        {t(
                          "homecleanorderform.order_form.service_details.categories.additional_services.title"
                        )}{" "}
                        {/* CHANGED: Added translation */}
                      </h4>
                      <div className="homecleanorder-services-grid">
                        <div className="homecleanorder-service-item">
                          <label className="homecleanorder-form-label">
                            {/* Furniture Cleaning */}
                            {t(
                              "homecleanorderform.order_form.service_details.categories.additional_services.labels.furniture"
                            )}{" "}
                            {/* CHANGED: Added translation */}
                          </label>
                          <div
                            className={`homecleanorder-service-value ${
                              formData.furniture > 0 ? "has-value" : ""
                            }`}
                          >
                            {formData.furniture}{" "}
                            <span className="homecleanorder-service-unit">
                              {/* units */}
                              {t(
                                formData.furniture === 1
                                  ? "homecleanorderform.order_form.service_details.unit"
                                  : "homecleanorderform.order_form.service_details.units"
                              )}{" "}
                              {/* CHANGED: Added translation for unit/units */}
                            </span>
                          </div>
                        </div>
                        <div className="homecleanorder-service-item">
                          <label className="homecleanorder-form-label">
                            {/* Cloth Cleaning */}
                            {t(
                              "homecleanorderform.order_form.service_details.categories.additional_services.labels.cloths"
                            )}{" "}
                            {/* CHANGED: Added translation */}
                          </label>
                          <div
                            className={`homecleanorder-service-value ${
                              formData.cloths > 0 ? "has-value" : ""
                            }`}
                          >
                            {formData.cloths}{" "}
                            <span className="homecleanorder-service-unit">
                              {/* units */}
                              {t(
                                formData.cloths === 1
                                  ? "homecleanorderform.order_form.service_details.unit"
                                  : "homecleanorderform.order_form.service_details.units"
                              )}{" "}
                              {/* CHANGED: Added translation for unit/units */}
                            </span>
                          </div>
                        </div>
                        <div className="homecleanorder-service-item">
                          <label className="homecleanorder-form-label">
                            {/* Dish Cleaning */}
                            {t(
                              "homecleanorderform.order_form.service_details.categories.additional_services.labels.dishes"
                            )}{" "}
                            {/* CHANGED: Added translation */}
                          </label>
                          <div
                            className={`homecleanorder-service-value ${
                              formData.dishes > 0 ? "has-value" : ""
                            }`}
                          >
                            {formData.dishes}{" "}
                            <span className="homecleanorder-service-unit">
                              {/* units */}
                              {t(
                                formData.dishes === 1
                                  ? "homecleanorderform.order_form.service_details.unit"
                                  : "homecleanorderform.order_form.service_details.units"
                              )}{" "}
                              {/* CHANGED: Added translation for unit/units */}
                            </span>
                          </div>
                        </div>

                        <div className="homecleanorder-service-item">
                          <label className="homecleanorder-form-label">
                            {t(
                              "homecleanorderform.order_form.service_details.categories.additional_services.labels.carpets_label"
                            )}
                          </label>
                          <div
                            className={`homecleanorder-service-value ${
                              formData.carpets > 0 ? "has-value" : ""
                            }`}
                          >
                            {formData.carpets}{" "}
                            <span className="homecleanorder-service-unit">
                              {formData.carpets === 1
                                ? t(
                                    "homecleanorderform.order_form.service_details.unit"
                                  )
                                : t(
                                    "homecleanorderform.order_form.service_details.units"
                                  )}
                            </span>
                          </div>
                        </div>

                        {formData.useSameServitor && previousServitorName && (
                          <div className="homecleanorder-service-item homecleanorder-rebook-item">
                            <label className="homecleanorder-form-label homecleanorder-label-content">
                              <FontAwesomeIcon
                                icon={faCheckCircle}
                                className="homecleanorder-rebook-icon"
                              />
                              {t("homecleanorderform.order_form.rebook.label")}
                            </label>
                            <div className="homecleanorder-service-value homecleanorder-rebook-value">
                              <strong>{previousServitorName}</strong>
                            </div>
                          </div>
                        )}

                        {formData.remarks && (
                          <div className="homecleanorder-service-item homecleanorder-remarks-item">
                            <label className="homecleanorder-form-label">
                              <FontAwesomeIcon
                                icon={faCommentAlt}
                                className="homecleanorder-remarks-icon"
                              />
                              {t(
                                "electricianorderform.order_form.service_details.categories.wiring_checkup.labels.remarks"
                              )}
                            </label>
                            <div className="homecleanorder-service-value has-value homecleanorder-remarks-value">
                              {formData.remarks}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="homecleanorder-order-actions">
              <button
                className="homecleanorder-btn homecleanorder-btn-outline"
                onClick={onClose}
              >
                {/* Cancel */}
                {t("homecleanorderform.order_form.actions.cancel")}{" "}
                {/* CHANGED: Added translation */}
              </button>
              <button
                className="homecleanorder-btn homecleanorder-btn-primary"
                onClick={handleSubmit}
                disabled={isSubmitting}
              >
                <FontAwesomeIcon icon={faTools} />
                {/* Place Order */}
                {/* {t("homecleanorderform.order_form.actions.place_order")}{" "} */}

                {isSubmitting
                  ? t("homecleanorderform.order_form.actions.placing", "Placing...")
                  : t("homecleanorderform.order_form.actions.place_order")}

              </button>
            </div>
          </div>
        </div>
      )}

      {showSuccessPopup && (
        <div className="homecleanorder-success-popup">
          <div className="homecleanorder-success-popup-content">
            <h2>
              {/* Order Successfully Placed! */}
              {t("homecleanorderform.order_form.success_popup.title")}{" "}
              {/* CHANGED: Added translation */}
            </h2>
            <p>
              {/* Thank you for choosing HelpNao. */}
              {t("homecleanorderform.order_form.success_popup.message1")}{" "}
              {/* CHANGED: Added translation */}
            </p>
            <p>
              {/* Your order is now pending confirmation. */}
              {t("homecleanorderform.order_form.success_popup.message2")}{" "}
              {/* CHANGED: Added translation */}
            </p>
            <button
              className="homecleanorder-btn homecleanorder-btn-primary"
              onClick={closePopup}
            >
              {/* Ok */}
              {t("homecleanorderform.order_form.success_popup.button")}{" "}
              {/* CHANGED: Added translation */}
            </button>
          </div>
        </div>
      )}

      {showBlockedPopup && (
        <div className="homecleanorder-success-popup">
          <div className="homecleanorder-success-popup-content">
            <h2>
              {/* Account Blocked */}
              {t("homecleanorderform.order_form.blocked_popup.title")}{" "}
              {/* CHANGED: Added translation */}
            </h2>
            <p>
              {/* Your account is blocked due to excessive cancellations. */}
              {t("homecleanorderform.order_form.blocked_popup.message1")}{" "}
              {/* CHANGED: Added translation */}
            </p>
            <p>
              {/* Please contact our support team for assistance. */}
              {t("homecleanorderform.order_form.blocked_popup.message2")}{" "}
              {/* CHANGED: Added translation */}
            </p>
            <button
              className="homecleanorder-btn homecleanorder-btn-primary"
              onClick={closeBlockedPopup}
            >
              {/* Close */}
              {t("homecleanorderform.order_form.blocked_popup.button")}{" "}
              {/* CHANGED: Added translation */}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default HomeCleanOrderForm;
